export enum CommunicationType {
  Message = 'message',
  Email = 'email'
}
